module.exports = require("@embedpdf/plugin-render/react");